import React, { useState } from "react";
import { Table, Select, Button, Input } from "antd";
import styles from "./VendorManagement.module.css";
import { useNavigate } from "react-router-dom";
import actionicon from "../../../../assets/images/actionicon.svg";
import {
  Dropdown,
  Modal,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import HeaderComponent from "../../../../components/HeaderComponent/HeaderComponent";
import { ReactComponent as ViewIcon } from "../../../../assets/images/view.svg";
import { ReactComponent as ArchiveIcon } from "../../../../assets/images/archive.svg";
import { ReactComponent as EditIcon } from "../../../../assets/images/editIcon.svg";

const { Option } = Select;

const VendorManagement = () => {
  const navigate = useNavigate();
  const [isModal, setIsModal] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [Category, setCategory] = useState({
    value: "Ingredients",
    id: 1,
  });

  const [statuss, setStatus] = useState({
    value: "Active",
    id: 1,
  });

  const handleDisplayFilter = () => {
    setShowFilter(true);
  };

  const columns = [
    {
      title: "No",
      dataIndex: "No",
      key: "No",
    },
    {
      title: "Vendor Name",
      dataIndex: "VendorName",
      key: "VendorName",
    },
    {
      title: "Contact Info",
      key: "ContactInfo",
      dataIndex: "ContactInfo",
    },
    {
      title: "Categories",
      dataIndex: "Category",
      key: "Category",
    },
    {
      title: "Last Order Date",
      key: "OrderDate",
      dataIndex: "OrderDate",
    },
    {
      title: "Action",
      key: "Action",
      dataIndex: "Action",
      render: (text) => (
        <div className={styles.itemsButtonDiv}>
          <ViewIcon
            className={styles.itemsButton}
            onClick={() =>
              navigate("/AdminVendorManagement/VendorManagementDetails")
            }
          />
          <EditIcon
            className={styles.itemsButton}
            onClick={() => navigate("/AdminVendorManagement/AdminEditVendor")}
          />
          <ArchiveIcon
            className={styles.itemsButton}
            onClick={() => setIsModal(true)}
          />
        </div>
      ),
    },
  ];

  const data = [
    {
      No: "1",
      VendorName: "John Doe",
      ContactInfo: "(214) 390-8650",
      Category: "Ingredients",
      OrderDate: "Jul 23, 2025",
    },
    {
      No: "2",
      VendorName: "Sarah Williams",
      ContactInfo: "(305) 442-9932",
      Category: "Materials",
      OrderDate: "Aug 02, 2025",
    },
    {
      No: "3",
      VendorName: "Michael Johnson",
      ContactInfo: "(509) 687-1149",
      Category: "Ingredients",
      OrderDate: "Jun 15, 2025",
    },
    {
      No: "4",
      VendorName: "Emily Davis",
      ContactInfo: "(702) 331-2204",
      Category: "Materials",
      OrderDate: "Sep 10, 2025",
    },
    {
      No: "5",
      VendorName: "Robert Brown",
      ContactInfo: "(415) 870-6653",
      Category: "Ingredients",
      OrderDate: "May 28, 2025",
    },
    {
      No: "6",
      VendorName: "Jessica Miller",
      ContactInfo: "(646) 553-7810",
      Category: "Materials",
      OrderDate: "Jul 04, 2025",
    },
    {
      No: "7",
      VendorName: "David Wilson",
      ContactInfo: "(312) 770-4489",
      Category: "Ingredients",
      OrderDate: "Oct 18, 2025",
    },
    {
      No: "8",
      VendorName: "Sophia Anderson",
      ContactInfo: "(213) 942-1173",
      Category: "Materials",
      OrderDate: "Aug 29, 2025",
    },
    {
      No: "9",
      VendorName: "James Martinez",
      ContactInfo: "(917) 335-9420",
      Category: "Ingredients",
      OrderDate: "Nov 05, 2025",
    },
    {
      No: "10",
      VendorName: "Olivia Taylor",
      ContactInfo: "(512) 603-7791",
      Category: "Materials",
      OrderDate: "Jun 09, 2025",
    },
  ];

  return (
    <div className={styles.mainCont}>
      <HeaderComponent
        heading={"Vendor Management"}
        showFilterIcon={true}
        onClickFilter={() => handleDisplayFilter()}
        onSearch={(e) => console.log(e.target.value)}
        onSubmit={() => navigate("/AdminVendorManagement/AdminAddVendor")}
        submitButtonText={"Create New Vendor"}
        // showBackIcon={true}
        showSubmitButton={true}
        showSearch={true}
      />

      <div className={styles.subCont}>
        <div className={styles.TableDiv}>
          <Table
            scroll={{ x: true }}
            columns={columns}
            dataSource={data}
            pagination={false}
            rowKey="No"
          />
        </div>
      </div>
      <Modal
        open={isModal}
        onClickOkButton={() => {
          setIsModal(false);
        }}
        onCancel={() => setIsModal(false)}
        className={styles.modalCont}
        title={"Archive"}
        headingClass={styles.modalHeading}
        width={"400px"}
        onClickCancelButton={() => setIsModal(false)}
        okBtnTitle={"Yes"}
        twoButton
        cancelBtnTitle={"No"}
        btnStyle={{ width: "200px", marginTop: "12px" }}
        onBtnPress={() => setIsModal(false)}
      >
        <div>
          <TextComponent
            text="Are you sure you want to archive? "
            className={styles.CardText}
          />
        </div>
      </Modal>

      {/* filter modal  */}

      <Modal
        open={showFilter}
        onClickOkButton={() => {
          setShowFilter(false);
        }}
        onCancel={() => setShowFilter(false)}
        className={styles.modalCont}
        title={"Filters"}
        headingClass={styles.modalHeading}
        width={"400px"}
        btnStyle={{ width: "200px", marginTop: "12px" }}
        twoButton
        onBtnPress={() => setShowFilter(false)}
        onClickCancelButton={() => setShowFilter(false)}
        okBtnTitle={"Apply Filters"}
        cancelBtnTitle={"Reset All"}
      >
        <Dropdown
          className={styles.input}
          label={"Category"}
          labelClass={styles.labelClass}
          value={Category}
          style={{ color: "var(--black-color)" }}
          options={[
            {
              value: "Ingredients",
              id: 1,
            },
            {
              value: "Materials",
              id: 2,
            },
          ]}
          onChange={(e) => setCategory(e)}
        />
        <Dropdown
          className={styles.input}
          label={"Status"}
          labelClass={styles.labelClass}
          value={statuss}
          style={{ color: "var(--black-color)" }}
          options={[
            {
              value: "Active",
              id: 1,
            },
            {
              value: "Archived",
              id: 2,
            },
          ]}
          onChange={(e) => setStatus(e)}
        />
      </Modal>
    </div>
  );
};

export default VendorManagement;
